import React from 'react';
import { Utensils, Hotel, Wine, Trees, PartyPopper } from 'lucide-react';

export const Audience = () => {
    return (
        <section style={{ padding: '120px 0', borderTop: '1px solid var(--border-subtle)', background: 'var(--bg-secondary)', position: 'relative' }}>
            <div className="container">
                <div style={{ textAlign: 'center', marginBottom: '80px', maxWidth: '800px', margin: '0 auto 80px auto' }}>
                    <h2 style={{ fontSize: 'clamp(2.5rem, 5vw, 3.5rem)', letterSpacing: '-0.02em', marginBottom: '24px' }}>
                        Built for Venues of Any Size.
                    </h2>
                    <p style={{ color: 'var(--text-tertiary)', fontSize: '1.25rem', lineHeight: 1.6 }}>
                        Configurable setups designed specifically for your layout.
                    </p>
                </div>

                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '24px' }}>
                    {[
                        { icon: Utensils, label: 'Restaurants' },
                        { icon: Hotel, label: 'Hotels & Room Service' },
                        { icon: Wine, label: 'Lounges & Bars' },
                        { icon: Trees, label: 'Resorts' },
                        { icon: PartyPopper, label: 'Event Centers' }
                    ].map((idx, i) => {
                        const Icon = idx.icon;
                        return (
                            <div key={i} className="glass-panel" style={{ padding: '32px 24px', textAlign: 'center', background: 'var(--bg-tertiary)', border: '1px solid var(--border-subtle)', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <Icon size={32} color="var(--accent-primary)" style={{ marginBottom: '16px' }} />
                                <h3 style={{ fontSize: '1.125rem', fontWeight: 600 }}>{idx.label}</h3>
                            </div>
                        )
                    })}
                </div>
            </div>
        </section>
    );
};
